/**
 * Takes string "YYYY-MM-DDTHH:mm:ss.sssZ" and returns "HH:mm"
 */
export const getTimeFromDateTimeString = (dateString: string) => {
  if (!dateString) return { time: '', timeWithSeconds: '' };
  const localTimeStamp = new Date(dateString || '').toLocaleString('sv-SE').slice(0, 16);
  const [, timePart] = localTimeStamp.split(' ');
  const [hours, minutes] = timePart.split(':');

  const time = `${hours}:${minutes}`;

  return time;
};
